export const downloadUrl = {
  downloadImg: "https://s2.blofin.com/frontend-images/dl-qr-light-v3.png",
  android: "https://play.google.com/store/apps/details?id=com.blofin.android",
  apk: "https://blofin.com/download/blofin.apk",
  ios: "https://apps.apple.com/app/id1564826288"
};

export const headerName = "blofin-nav-header";

export const footerName = "blofin-nav-footer";

export const footerText = "© 2023-2026 BLOFIN.COM";

export const textWeight = "font-medium";

export const textNickNameWeight = "font-medium";

export const copyTradingHeader = "blofin-copy-trading-user";

// ==================== RewardHub全流程触达配置 START ===================

// 是否展示新用户Banner
export const showNewUserBanner = true;

// 是否展示可解锁奖励卡片
export const showUnlockableRewardCard = true;

/** 下载任务二维码样式 */
export const downloadImgStyles = "";

/** 点击 Deposit 按钮是否展示右侧 Drawer（韩国站无 Buy Crypto，直接跳转充币页） */
export const showDepositDrawer = true;

// ==================== RewardHub全流程触达配置 END ====================
// 默认币种图标（加载失败时的兜底）
export const defaultCoinIcon = "https://s2.blofin.com/static/currency/icon/default-v3.png";

// CDN 图片裁剪代理域名
export const cdnHost = "https://blofin.com";
